import { Box, Tooltip } from '@mantine/core';
import classes from './ScanTagList.module.css';
import { TagsTooltip } from './TagsTooltip';
import type { ScanTagProps } from './ScanTag';
import { ScanTag } from './ScanTag';

export const ScanTagList = (props: { tags: ScanTagProps[] }) => {
  const numOfTags = props.tags.length;

  return (
    <Box display="flex" style={{ gap: 4 }}>
      {props.tags.slice(0, 2).map((i, idx) => (
        <ScanTag key={idx} {...i} />
      ))}
      {numOfTags > 2 && (
        <Tooltip
          multiline
          label={<TagsTooltip tags={props.tags.slice(2)} />}
          classNames={{ tooltip: classes.tooltip }}
          withArrow
        >
          <Box
            data-testid="scan-tag-overflow-badge"
            className={classes.overflowBadge}
            fw={500}
            fz="xs"
            ta="center"
          >
            +{numOfTags - 2}
          </Box>
        </Tooltip>
      )}
    </Box>
  );
};
